<app-header [title]="title"></app-header>

<div class="container-fluid">
    <div class="row">
        <div class="col-md-3 col-xs-4 p-0 ueser-crt blue-seprator serpartion-htg">
            <div class="col-md-12 col-sm-12">
                <div class="heading-panel sT-hight p-0">
                    <span class="text-sm text-ellipsis heading-txt t-uppercase blue-text">Concluder Report</span>
                </div>
            </div>
            <div class="col-md-12 col-xs-12 p-0 box-heightLG">

                <div class="col-md-12 col-xs-12 p-0">
                    <div class="form-group mh-15 mr-5">
                        <label for="inputEmail3" class="label-std  control-label p-0 b-600">Process</label>
                        <select class="form-control">
                            <option [ngValue]="undefined" disabled>Select Process</option>
                        </select>
                    </div>
                </div>

                <div class="col-md-12 col-xs-12 p-0">
                    <div class="form-group mh-15 mr-5">
                        <label for="inputEmail3" class="label-std  control-label p-0 b-600">Configuration</label>
                        <select class="form-control">
                            <option [ngValue]="undefined" disabled>Select Configuration</option>
                        </select>
                    </div>
                </div>

                <div class="col-md-12 col-xs-12">
                    <div class="col-md-12 col-xs-12 text-center p-0">
                        <button type="button" class="btn blue square-btn blue-hover btn-txt mr-10 mt-15 mb-5 w-51 btn-default"
                            (click)="clearForm()">Clear</button>
                        <button type="submit" class="btn blue square-btn blue-hover btn-txt mt-15 mb-5 w-51 btn-default"
                            data-toggle="modal" data-target=".skip-ac" [disabled]="submitBtnDisable">Submit</button>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-md-5 col-md-offset-2">
            <div class="col-md-12 col-sm-12 p-0">
                <div class="heading-panel sT-hight p-0">
                    <span class="text-sm text-ellipsis heading-txt t-uppercase blue-text">De-Allocate Concluder Employee
                        Wise</span>
                    <!-- <div class="right-most">Total Rows:- <b>{{rowData == null ? '0' : rowData.length}}</b></div> -->
                    <div class="right-most">
                        <button type="button" class="btn blue square-btn blue-hover btn-txt mt-15 mb-5 mr-10 btn-default"
                         data-target=".skip-ac">De-Allocate</button>
                    </div>

                </div>
            </div>
            <div class="col-md-12 col-sm-12 p-0">
                <div class="table-responcive">
                    <div class="sticky-table sticky-ltr-cells border-0 table-hight">
                        <ag-grid-angular style="height: 75vh;" [enableColResize]="true" [enableSorting]="true"
                            [enableFilter]="true" [pagination]="true" [paginationPageSize]="15"
                            class="ag-theme-balham grid-w" [rowData]="rowData" [columnDefs]="columnDefs"
                            (cellClicked)='onCellClicked($event)' [suppressDragLeaveHidesColumns]="true"
                            [suppressColumnVirtualisation]="true" [rowSelection]="rowSelection"
                            (firstDataRendered)="autoSizeAll()" (gridReady)="onGridReady($event)">
                        </ag-grid-angular>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
